/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { Comment } from '../models/comment';
import { CommentPartial } from '../models/comment-partial';
import { CommentWithRelations } from '../models/comment-with-relations';
import { CreateDiagramCommentResponseDto } from '../models/create-diagram-comment-response-dto';
import { CreatePageCommentResponseDto } from '../models/create-page-comment-response-dto';
import { NewComment } from '../models/new-comment';
import { NewCommentReply } from '../models/new-comment-reply';
import { NewDiagramComment } from '../models/new-diagram-comment';
import { NewPageComment } from '../models/new-page-comment';
import { Count as LoopbackCount } from '../models/loopback/count';

@Injectable({
  providedIn: 'root',
})
export class CommentControllerService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation commentControllerFindByAdmin
   */
  static readonly CommentControllerFindByAdminPath = '/admin/comments';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findByAdmin()` instead.
   *
   * This method doesn't expect any request body.
   */
  findByAdmin$Response(params?: {
    filter?: any;
  }): Observable<StrictHttpResponse<Array<CommentWithRelations>>> {

    const rb = new RequestBuilder(this.rootUrl, CommentControllerService.CommentControllerFindByAdminPath, 'get');
    if (params) {
      rb.query('filter', params.filter, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<CommentWithRelations>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `findByAdmin$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  findByAdmin(params?: {
    filter?: any;
  }): Observable<Array<CommentWithRelations>> {

    return this.findByAdmin$Response(params).pipe(
      map((r: StrictHttpResponse<Array<CommentWithRelations>>) => r.body as Array<CommentWithRelations>)
    );
  }

  /**
   * Path part for operation commentControllerCount
   */
  static readonly CommentControllerCountPath = '/comments/count';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `count()` instead.
   *
   * This method doesn't expect any request body.
   */
  count$Response(params?: {
    where?: any;
  }): Observable<StrictHttpResponse<LoopbackCount>> {

    const rb = new RequestBuilder(this.rootUrl, CommentControllerService.CommentControllerCountPath, 'get');
    if (params) {
      rb.query('where', params.where, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<LoopbackCount>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `count$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  count(params?: {
    where?: any;
  }): Observable<LoopbackCount> {

    return this.count$Response(params).pipe(
      map((r: StrictHttpResponse<LoopbackCount>) => r.body as LoopbackCount)
    );
  }

  /**
   * Path part for operation commentControllerCreateDiagramComment
   */
  static readonly CommentControllerCreateDiagramCommentPath = '/comments/diagram-comment';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createDiagramComment()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createDiagramComment$Response(params?: {
    body?: NewDiagramComment
  }): Observable<StrictHttpResponse<CreateDiagramCommentResponseDto>> {

    const rb = new RequestBuilder(this.rootUrl, CommentControllerService.CommentControllerCreateDiagramCommentPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CreateDiagramCommentResponseDto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `createDiagramComment$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createDiagramComment(params?: {
    body?: NewDiagramComment
  }): Observable<CreateDiagramCommentResponseDto> {

    return this.createDiagramComment$Response(params).pipe(
      map((r: StrictHttpResponse<CreateDiagramCommentResponseDto>) => r.body as CreateDiagramCommentResponseDto)
    );
  }

  /**
   * Path part for operation commentControllerCreatePageComment
   */
  static readonly CommentControllerCreatePageCommentPath = '/comments/page-comment';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createPageComment()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createPageComment$Response(params?: {
    body?: NewPageComment
  }): Observable<StrictHttpResponse<CreatePageCommentResponseDto>> {

    const rb = new RequestBuilder(this.rootUrl, CommentControllerService.CommentControllerCreatePageCommentPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CreatePageCommentResponseDto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `createPageComment$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createPageComment(params?: {
    body?: NewPageComment
  }): Observable<CreatePageCommentResponseDto> {

    return this.createPageComment$Response(params).pipe(
      map((r: StrictHttpResponse<CreatePageCommentResponseDto>) => r.body as CreatePageCommentResponseDto)
    );
  }

  /**
   * Path part for operation commentControllerReply
   */
  static readonly CommentControllerReplyPath = '/comments/reply/{parentCommentId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reply()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  reply$Response(params: {
    parentCommentId: string;
    body?: NewCommentReply
  }): Observable<StrictHttpResponse<Comment>> {

    const rb = new RequestBuilder(this.rootUrl, CommentControllerService.CommentControllerReplyPath, 'post');
    if (params) {
      rb.path('parentCommentId', params.parentCommentId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Comment>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `reply$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  reply(params: {
    parentCommentId: string;
    body?: NewCommentReply
  }): Observable<Comment> {

    return this.reply$Response(params).pipe(
      map((r: StrictHttpResponse<Comment>) => r.body as Comment)
    );
  }

  /**
   * Path part for operation commentControllerFindById
   */
  static readonly CommentControllerFindByIdPath = '/comments/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findById()` instead.
   *
   * This method doesn't expect any request body.
   */
  findById$Response(params: {
    id: string;
    filter?: any;
  }): Observable<StrictHttpResponse<CommentWithRelations>> {

    const rb = new RequestBuilder(this.rootUrl, CommentControllerService.CommentControllerFindByIdPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
      rb.query('filter', params.filter, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CommentWithRelations>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `findById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  findById(params: {
    id: string;
    filter?: any;
  }): Observable<CommentWithRelations> {

    return this.findById$Response(params).pipe(
      map((r: StrictHttpResponse<CommentWithRelations>) => r.body as CommentWithRelations)
    );
  }

  /**
   * Path part for operation commentControllerDeleteById
   */
  static readonly CommentControllerDeleteByIdPath = '/comments/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteById()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteById$Response(params: {
    id: string;
  }): Observable<StrictHttpResponse<any>> {

    const rb = new RequestBuilder(this.rootUrl, CommentControllerService.CommentControllerDeleteByIdPath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<any>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `deleteById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteById(params: {
    id: string;
  }): Observable<any> {

    return this.deleteById$Response(params).pipe(
      map((r: StrictHttpResponse<any>) => r.body as any)
    );
  }

  /**
   * Path part for operation commentControllerUpdateById
   */
  static readonly CommentControllerUpdateByIdPath = '/comments/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateById()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateById$Response(params: {
    id: string;
    body?: CommentPartial
  }): Observable<StrictHttpResponse<any>> {

    const rb = new RequestBuilder(this.rootUrl, CommentControllerService.CommentControllerUpdateByIdPath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<any>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `updateById$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateById(params: {
    id: string;
    body?: CommentPartial
  }): Observable<any> {

    return this.updateById$Response(params).pipe(
      map((r: StrictHttpResponse<any>) => r.body as any)
    );
  }

  /**
   * Path part for operation commentControllerFind
   */
  static readonly CommentControllerFindPath = '/comments';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `find()` instead.
   *
   * This method doesn't expect any request body.
   */
  find$Response(params?: {
    filter?: any;
  }): Observable<StrictHttpResponse<Array<CommentWithRelations>>> {

    const rb = new RequestBuilder(this.rootUrl, CommentControllerService.CommentControllerFindPath, 'get');
    if (params) {
      rb.query('filter', params.filter, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<CommentWithRelations>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `find$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  find(params?: {
    filter?: any;
  }): Observable<Array<CommentWithRelations>> {

    return this.find$Response(params).pipe(
      map((r: StrictHttpResponse<Array<CommentWithRelations>>) => r.body as Array<CommentWithRelations>)
    );
  }

  /**
   * Path part for operation commentControllerCreate
   */
  static readonly CommentControllerCreatePath = '/comments';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `create()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  create$Response(params?: {
    body?: NewComment
  }): Observable<StrictHttpResponse<Comment>> {

    const rb = new RequestBuilder(this.rootUrl, CommentControllerService.CommentControllerCreatePath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Comment>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `create$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  create(params?: {
    body?: NewComment
  }): Observable<Comment> {

    return this.create$Response(params).pipe(
      map((r: StrictHttpResponse<Comment>) => r.body as Comment)
    );
  }

}
